import React from 'react';
import { connect } from 'react-redux';

import { CLIENT_SHOW, USER_ACCOUNT_EDIT, USER_PROFILE_EDIT, USER_LOGOUT } from 'src/constants/EndpointUrls';
import { Pulldown, User, Question } from 'jbc-front/components/icons';
import DropDownMenu from 'src/components/DropDownMenu';
import { redirectTo } from 'src/utils/Http';
import _ from 'lodash';
import { withTranslation } from 'react-i18next'

import styles from './Header.scss';

export class ShowCurrentUser extends React.Component {
  // ユーザー種別ごとのメニューアイテムを作成
  // 従業員を持つアカウントは、プロフィールへの動線のみ
  // 従業員を持たないアカウントは、アカウント変更、及びログアウト
  createMenuItems(currentUser) {
    const { t } = this.props;
    const profile = {
      id: 0,
      onClick: () => redirectTo(USER_PROFILE_EDIT),
      label: t('features.Users.components.SettingSideBar.profile')
    };
    const accountSetting = {
      id: 1,
      onClick: () => redirectTo(USER_ACCOUNT_EDIT),
      label: t("components.Navbar.Account_setting")
    };
    const logout = {
      id: 2,
      onClick: () => redirectTo(USER_LOGOUT),
      label: t("components.Navbar.Logout")
    };
    if (currentUser.hasEmployee) {
      return [profile];
    }
    return [accountSetting, logout];
  }

  render() {
    const { currentUser } = this.props;
    const name = _.get(currentUser, 'fullName') || null;
    const menuItems = this.createMenuItems(currentUser);

    const toggle = ({ onClick }) => (
      <a className={styles.link} onClick={onClick} role="presentation">
        <User size={30} />
        <span className={styles.email}>{name}</span>
        <span className={styles.pulldown}>
          <Pulldown size={10} />&nbsp;
        </span>
      </a>
    );

    return <DropDownMenu toggle={toggle} menuItems={menuItems} />;
  }
}

const CurrentUserInfo = ({ currentUser, currentClient, t, i18n }) => (
  <div className={styles.wrap}>
    {/* <div className={styles.help}>
      <a
        className={styles.menu}
        target="_blank"
        rel="noopener noreferrer"
        href="https://jobcan-payroll.zendesk.com/hc/ja"
      >
        <Question size={20} />{t("components.Navbar.Help")}
      </a>
    </div> */}
    <div className={styles.client}>
      <a href={CLIENT_SHOW} className={styles.link}>
        {currentClient.officeName}
      </a>
    </div>
    <div className={styles.user}>
      <ShowCurrentUser currentUser={currentUser} t={t} i18n={i18n} />
    </div>
  </div>
);

export default connect(state => ({
  currentClient: state.currentClient.item.data
}))(withTranslation()(CurrentUserInfo));
